import theme from 'stories/utils/theme'
import styled from 'styled-components'
import Icon from 'assets/app_logo.svg'
import { ButtonText, Overline, Subtitle2 } from 'stories/elements/Typography/Text'
import DownloadButton from 'components/modules/SEO/DownloadBanner'
import { useRouter } from 'next/router'
import { Know } from 'interfaces/Know'
import { getDefaultMetaTitle } from 'lib/constants/language'
import { NewButtonLink } from 'components/elements/NewButton'
import { signUpRoute, appKnowRoute } from 'lib/constants/routes'
import _useTranslation from 'lib/hooks/_useTranslation'
import { useSelector } from 'react-redux'
import { AppState } from 'redux/reducer'
import { getMobileOS } from 'lib/tracking/attribution/device'
import { isDeviceMobile } from 'lib/features/deviceInfo'
import { appDeepLinkKnow } from 'lib/features/app-deep-links'
import { getCountryLanguageConfig } from 'lib/constants/countryLanguageConfig'

const Container = styled.div`
    background: ${theme.colors.white};
    position: relative;
    height: 80px;
    display: grid;
    align-content: center;
`

const Wrapper = styled.div`
    display: flex;
    padding: 0px 50px;
    grid-gap: 20px;
    place-items: center;
    overflow: hidden;

    * {
        z-index: 5;
    }
    .buttons {
        position: absolute;
        right: 50px;
    }
`

interface Props {
    onDownloadButtonClick(platform: 'android' | 'ios'): void
    know: Know
}

const KnowContentConversionBanner = (props: Props) => {
    const { locale } = useRouter()
    const { t } = _useTranslation('knows')
    const countryLanguageConfig = getCountryLanguageConfig(locale)
    const isLaunched = !!countryLanguageConfig?.isLaunched
    const authenticatedUser = useSelector((state: AppState) => state.user)
    const isMobile = isDeviceMobile()

    const showWebappConversionEntryPoint = !authenticatedUser && !isMobile

    const showWebappSignupForm = !isMobile && !authenticatedUser

    if (!isLaunched) return null

    const appMotto = getDefaultMetaTitle(locale)
    const mobileOS = getMobileOS()

    const downloadDeepLinkPath = appDeepLinkKnow(props.know.uuid)

    return (
        <Container>
            <Wrapper>
                <Icon />
                <div>
                    <Subtitle2 color={theme.colors.headlineDark}>Knowunity</Subtitle2>
                    <Overline className="motto" color={theme.colors.actionGray}>
                        {appMotto}
                    </Overline>
                </div>

                {showWebappSignupForm ? null : (
                    <div className="buttons">
                        {showWebappConversionEntryPoint ? (
                            <>
                                {!authenticatedUser ? (
                                    <NewButtonLink
                                        borderRadius={theme.borderRadius.normal}
                                        color={theme.colors.deepSeaBlue}
                                        href={signUpRoute({
                                            referrerScreen: 'knowContentDialogBottomSignUpButton',
                                            redirect: props.know
                                                ? appKnowRoute(props.know.uuid, { referrerScreen: 'seoKnow' })
                                                : undefined,
                                        })}
                                    >
                                        <ButtonText color={theme.colors.white} style={{ width: '100%' }}>
                                            {t('knows/knowDetailsConversionDialogSignUpButtonText')}
                                        </ButtonText>
                                    </NewButtonLink>
                                ) : null}
                            </>
                        ) : (
                            <>
                                {mobileOS ? (
                                    <DownloadButton
                                        isDark
                                        type="ios"
                                        onClick={() => props.onDownloadButtonClick('ios')}
                                        downloadDeepLinkPath={downloadDeepLinkPath}
                                        referrerScreen="know-content-bottom-banner"
                                    />
                                ) : (
                                    <DownloadButton
                                        isDark
                                        type="android"
                                        onClick={() => props.onDownloadButtonClick('android')}
                                        downloadDeepLinkPath={downloadDeepLinkPath}
                                        referrerScreen="know-content-bottom-banner"
                                    />
                                )}
                            </>
                        )}
                    </div>
                )}
            </Wrapper>
        </Container>
    )
}

export default KnowContentConversionBanner
